import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { PermissionService } from '../../shared/services/permissions.service';
import { Observable } from 'rxjs';

@Injectable()
export class WorkspaceCreationGuard {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.permissionService.canCreateWorkspace()) {
      this.router.navigate(['/entry']);
      return false;
    }

    return true;
  }
}
